var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19559 5.58468H7.67586V6.82014C8.03314 6.10958 8.94939 5.47115 10.3258 5.47115C12.9643 5.47115 13.5907 6.88559 13.5907 9.48073V14.287H10.9194V10.0717C10.9194 8.59386 10.5622 7.76043 9.6526 7.76043C8.39109 7.76043 7.86686 8.65864 7.86686 10.0711V14.287H5.19559V5.58468ZM0.615031 14.1735H3.2863V5.47115H0.615031V14.1735ZM3.66896 2.6336C3.66906 2.8575 3.62465 3.07919 3.53832 3.28578C3.452 3.49237 3.32547 3.67974 3.16609 3.837C2.84314 4.15797 2.40599 4.33764 1.95066 4.33653C1.49614 4.33623 1.06 4.15702 0.736573 3.83767C0.577774 3.67987 0.451673 3.49229 0.365497 3.28568C0.27932 3.07906 0.234762 2.85747 0.234375 2.6336C0.234375 2.18149 0.414686 1.74874 0.737241 1.42952C1.06039 1.10974 1.49671 0.930464 1.95133 0.930664C2.40678 0.930664 2.84354 1.11031 3.16609 1.42952C3.48798 1.74874 3.66896 2.18149 3.66896 2.6336Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4358d775aa3772bdea9eb29b5c9ee4b3.svg";
export { ForwardRef as ReactComponent };